import { c as n } from "./ghl-ui.es404.js";
import r from "./ghl-ui.es1181.js";
const {
  cubicBezierEaseInOut: a
} = r;
function m({
  originalTransform: o = "",
  left: i = 0,
  top: t = 0,
  transition: c = `all .3s ${a} !important`
} = {}) {
  return [n("&.icon-switch-transition-enter-from, &.icon-switch-transition-leave-to", {
    transform: o + " scale(0.75)",
    left: i,
    top: t,
    opacity: 0
  }), n("&.icon-switch-transition-enter-to, &.icon-switch-transition-leave-from", {
    transform: `scale(1) ${o}`,
    left: i,
    top: t,
    opacity: 1
  }), n("&.icon-switch-transition-enter-active, &.icon-switch-transition-leave-active", {
    transformOrigin: "center",
    position: "absolute",
    left: i,
    top: t,
    transition: c
  })];
}
export {
  m as iconSwitchTransition
};
